import React from "react";
import { Grid } from "@mui/material";
import TileCard from "./TileCard";

export default function TileGrid({ items }) {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <Grid container spacing={2}>
      {items.map((item) => (
        <Grid item xs={6} sm={4} md={3} lg={2} key={item.id}>
          <TileCard item={item} />
        </Grid>
      ))}
    </Grid>
  );
}
